import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Popover from "@material-ui/core/Popover"
import { InfoOutlined } from "@material-ui/icons"
import hetmapImage from "../../../images/hetmap.png"

const useStyles = makeStyles((theme) => ({
	ColorLegendImage: {
		width: 250,
	},
}))

const ColorLegend = ({ anchorEl, setAnchorEl, open, id }) => {
	const classes = useStyles()

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<div>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<img src={hetmapImage} alt="Color Legend" className={classes.ColorLegendImage} />
			</Popover>
		</div>
	)
}

export default ColorLegend
